export function toggleElementInCollection(item, collection) {
  if (collection.has(item)) {
    collection.delete(item);
  } else {
    collection.add(item);
  }

  return Array.from(collection);
}